module.exports = __webpack_public_path__ + "img/01_bg.885eb8e6.jpg";